export default __webpack_public_path__ + "static/media/thumbnail2.0a705d04.jpg";